// Shared marketing CRM helpers (status meta, formatters).
export const LEAD_STATUSES = ["new", "contacted", "quoted", "negotiation", "won", "lost"];

export const STATUS_META = {
  new: { label: "جديد", cls: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400" },
  contacted: { label: "تم التواصل", cls: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500" },
  quoted: { label: "عرض سعر", cls: "bg-indigo-50 text-indigo-700 border-indigo-200", dot: "bg-indigo-500" },
  negotiation: { label: "تفاوض", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  won: { label: "مشترك ✅", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  lost: { label: "مرفوض", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

export const money = (n) => `${(Number(n) || 0).toLocaleString("en-US")} ⃁`;

export const fmtDate = (v) => {
  if (!v) return "—";
  try { return new Date(v).toLocaleDateString("ar-EG", { year: "numeric", month: "short", day: "numeric" }); }
  catch { return "—"; }
};

export const fmtHM = (secs) => {
  const s = Math.max(0, Math.floor(Number(secs) || 0));
  const h = Math.floor(s / 3600); const m = Math.floor((s % 3600) / 60);
  return `${h}س ${m}د`;
};

export const PLAN_OPTIONS = [
  { v: "starter", label: "الأساسية" },
  { v: "business", label: "الأعمال" },
  { v: "professional", label: "الاحترافية" },
  { v: "enterprise", label: "المؤسسات" },
];

export const waLink = (phone, msg = "") => {
  let d = String(phone || "").replace(/[^\d]/g, "");
  if (!d) return "#";
  if (d.startsWith("00")) d = d.slice(2);
  else if (d.startsWith("0")) d = "966" + d.slice(1);
  else if (d.length === 9) d = "966" + d;
  return `https://wa.me/${d}${msg ? `?text=${encodeURIComponent(msg)}` : ""}`;
};

// returns "overdue" | "today" | null based on a YYYY-MM-DD follow-up date
export const followUpDue = (v) => {
  if (!v) return null;
  const d = String(v).slice(0, 10);
  const today = new Date().toISOString().slice(0, 10);
  if (d < today) return "overdue";
  if (d === today) return "today";
  return null;
};
